import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";

import type { HapticFeedbackSignal } from "../config/haptic-feedback";

export interface CapacitorHapticsPlugin {
  impact(options: { readonly style: ImpactStyle }): Promise<void>;
  notification(options: { readonly type: NotificationType }): Promise<void>;
}

export class CapacitorHapticBoundary {
  public constructor(
    private readonly native: boolean,
    private readonly plugin: CapacitorHapticsPlugin = Haptics,
  ) {}

  public isSupported(): boolean {
    return this.native;
  }

  public play(signal: HapticFeedbackSignal): Promise<void> {
    if (!this.native) {
      return Promise.resolve();
    }
    if (signal === "notification-success") {
      return this.plugin.notification({ type: NotificationType.Success });
    }
    const styleBySignal: Readonly<
      Record<Exclude<HapticFeedbackSignal, "notification-success">, ImpactStyle>
    > = {
      "impact-heavy": ImpactStyle.Heavy,
      "impact-light": ImpactStyle.Light,
      "impact-medium": ImpactStyle.Medium,
    };
    return this.plugin.impact({ style: styleBySignal[signal] });
  }
}
